module.exports = __webpack_public_path__ + "img/mogliara.dee84651.png";